import { Route, Routes } from 'react-router-dom';
import IncomeVerification from '../containers/verification';
import IncomeVerificationAccount from '../containers/verification/account';
import IncomeVerificationIntro from '../containers/verification/intro';
import CoSignApplicants from '../containers/verification/cosign';
import IncomeVerificationTypes from '../containers/verification/type';
import IncomeVerificationReceived from '../containers/verification/received';
import DocumentUpload from '../containers/verification/upload';
import DocUploadInstructions from '../containers/verification/upload/instructions';
import DocUploadSelect from '../containers/verification/upload/select';
import DocUploadReview from '../containers/verification/upload/review';
import DocUploadFallback from '../containers/verification/upload/fallback';
import EmployerVerification from '../containers/employer-verification';
import NotFound from '../containers/not-found';

export default function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="employer-verification" element={<EmployerVerification />} />
      <Route path=":propertyCode/verification" element={<IncomeVerification />}>
        <Route index element={<IncomeVerificationAccount />} />
        <Route path="intro" element={<IncomeVerificationIntro />} />
        <Route path="cosign" element={<CoSignApplicants />} />
        <Route path="types" element={<IncomeVerificationTypes />} />
        <Route path="upload" element={<DocumentUpload />}>
          <Route index element={<DocUploadInstructions />} />
          <Route path="select" element={<DocUploadSelect />} />
          <Route path="review" element={<DocUploadReview />} />
          <Route path="fallback" element={<DocUploadFallback />} />
        </Route>
        <Route path="confirmation" element={<IncomeVerificationReceived />} />
      </Route>
      {/* Not a way into the flow (that needs a property code and token): unknown URLs get the invalid-link screen instead of a blank page. */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
